import React, { useCallback } from "react";
import {
  Content,
  SpecLabel,
  ContentItemWrap,
  ModelName,
  SpecWrap,
} from "./elements";
import { Spec } from "../PurchasedList";

export interface Props {
  model: {
    name: string;
    spec: Spec[];
  }[];
  setSelectedName: React.Dispatch<React.SetStateAction<string>>;
  setSelectedSpec: React.Dispatch<any>;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PurchasedItem: React.FC<Props> = React.memo(
  ({ model, setSelectedName, setSelectedSpec, setIsModalOpen }) => {
    const handleModalOpen = useCallback((name: string, gb: string) => {
      setSelectedName(name);
      const selectedSpec = model
        .flatMap((m) => m.spec)
        .find((s) => s.gb === gb);
      setSelectedSpec(selectedSpec);
      setIsModalOpen(true);
    }, []);

    return (
      <Content>
        {model.map(({ name, spec }, index) => (
          <ContentItemWrap key={`model-label${index}`}>
            <ModelName>{name}</ModelName>
            <SpecWrap>
              {spec.map(({ gb }, index) => {
                return (
                  <SpecLabel
                    key={`spec-label${index}`}
                    onClick={() => handleModalOpen(name, gb)}
                  >
                    {gb}
                  </SpecLabel>
                );
              })}
            </SpecWrap>
          </ContentItemWrap>
        ))}
      </Content>
    );
  }
);

PurchasedItem.displayName = "PurchasedItem";
